import { memo } from "react";
import { HStack } from "@/shared/ui/Stack";
import { TEXT_VERTICAL_ALIGN_ICONS } from "../../constants/textVerticalAlignIcons";
import { MenuButton } from "../MenuButton/MenuButton";

interface TextVerticalAlignMenuContentProps {
    onTextAlignButtonClick: (align: string) => void;
}

export const TextVerticalAlignMenuContent = memo(function TextVerticalAlignMenuContent({
    onTextAlignButtonClick,
}: TextVerticalAlignMenuContentProps) {
    return (
        <HStack gap={2}>
            {Object.entries(TEXT_VERTICAL_ALIGN_ICONS).map(([align, Icon]) => (
                <MenuButton key={align} onClick={() => onTextAlignButtonClick(align)}>
                    <Icon />
                </MenuButton>
            ))}
        </HStack>
    );
});
